import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// WU-HERO: three selling points (reach, speed, fees). Each typed headline and its line live in one object,
// so they can never be shown out of step.
export const HERO_SLIDE_KEYS = ['reach', 'speed', 'fees'] as const;
export type HeroSlideKey = (typeof HERO_SLIDE_KEYS)[number];

export type HeroSlide = {
  key: HeroSlideKey;
  prefix: string;
  accent: string;
  suffix: string;
  body: string;
};

export function useHeroSlides(): HeroSlide[] {
  // react-i18next gives a new t when the language changes, so t alone keys the memo.
  const { t } = useTranslation();
  return useMemo(
    () =>
      HERO_SLIDE_KEYS.map((key) => ({
        key,
        prefix: t(`hero.slides.${key}.prefix`),
        accent: t(`hero.slides.${key}.accent`),
        suffix: t(`hero.slides.${key}.suffix`),
        body: t(`hero.slides.${key}.body`),
      })),
    [t],
  );
}
